<template>
    <div class="toggles">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "Toggles",

        props: {
            accordion: {
                type: Boolean,
                default: false
            },
            rememberActive: {
                type: Boolean,
                default: true
            }
        },

        created() {
            var lsn = "pxn.toggles.activeToggleId";
            window.localStorage.setItem(lsn, window.localStorage.getItem(lsn) || "[]");
            this.$on('toggle', this.toggle);
        },

        methods: {
            toggle($currentChild) {
                if (!this.accordion || !$currentChild.isActive) {
                    $currentChild.isActive = !$currentChild.isActive;
                }

                if (this.accordion) {
                    this.$children.forEach($child => {
                        if ($child !== $currentChild) {
                            $child.isActive = false;
                        }
                    });
                }
            }
        }
    };
</script>
